(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldSinglechoicedropdown', fbFieldSinglechoicedropdownDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/singlechoicedropdown';

    function fbFieldSinglechoicedropdownDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                return $templateCache.get(defaultTemplateUrl);
            },
            controller: fbFieldSinglechoicedropdownDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldSinglechoicedropdownDirectiveCtrl(lodash, FbQuestionWrapperService) {
        var vm = this;
        this.$onInit = function() {
            vm.onChange = function() {
                return FbQuestionWrapperService.onChange(vm);
            };
            vm.showTextBox = function() {
                return FbQuestionWrapperService.showTextbox(vm);
            };
            vm.onBlur = function($event) {
                if (vm.showText()) {
                    FbQuestionWrapperService.onBlur(vm, $event.target);
                }
            };

            if (lodash.has(vm.element,'options.settings.showText')) {
                vm.showText = '<fb-field-show-text-field element="vm.element" model="vm.model"></fb-field-show-text-field>';
            }
        };
    }
})();